import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AuthRoute } from './AuthRoute';
import { PrivateRoute } from './PrivateRoute';

const WrappedRoutes = React.lazy(() => import("./WrappedRoutes"));
const AuthRoutes = React.lazy(() => import("./AuthRoutes"));

const Router = () => (
  <Switch>
    <AuthRoute path="/auth" component={AuthRoutes} />
    <PrivateRoute path="/" component={WrappedRoutes} />
  </Switch>
);

export default Router;